import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export function LoginStyleBtn({
  onClick,
  children,
  className,
  disabled,
}: {
  onClick: () => void
  children: React.ReactNode
  className?: string
  disabled?: boolean
}) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'bg-gradient-to-r from-[#FD12E4] to-[#15F1FD] hover:from-[#FD12E4] hover:to-[#15F1FD] transition-colors duration-200 rounded-full relative overflow-hidden shadow-sm',
        'text-white',
        'sm:pl-10 sm:pr-10 sm:py-1',
        'hover:border-cyber-blue hover:shadow-neon-blue hover:text-white  transition-all duration-300',
        className,
      )}
    >
      {/* <span className="text-white text-sm relative z-10">{children}</span> */}
      {children}
      <div className="absolute inset-[-2px] bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shine-soft" />
    </Button>
  )
}

export function LoginStyleBtnV2({
  onClick,
  children,
  className,
  disabled,
}: {
  onClick: () => void
  children: React.ReactNode
  className?: string
  disabled?: boolean
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'flex items-center justify-center gap-2 whitespace-nowrap text-body font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/20 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
        // 'h-10 px-base py-sm rounded-lg',
        'bg-gradient-to-r from-[#FD12E4] to-[#15F1FD] hover:from-[#FD12E4] hover:to-[#15F1FD] transition-colors duration-200 rounded-full pl-10 pr-10 py-1 relative overflow-hidden shadow-sm',
        'text-white',
        'hover:border-cyber-blue hover:shadow-neon-blue hover:text-white  transition-all duration-300',
        className,
      )}
    >
      {/* <span className="text-white text-sm relative z-10">{children}</span> */}
      {children}
      <div className="absolute inset-[-2px] bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shine-soft" />
    </button>
  )
}
